export default {
  api: {
    baseUrl: 'https://cabinet.maxbonus.ru/cloud/service.php',
    baseUrlV2: 'https://api.maxbonus.ru:38200/api/',
    userCreate: 'https://cabinet.maxbonus.ru/user-create/'
  }
};